const firebaseConfig = {
    apiKey: "AIzaSyDgkisTQcj2dzh1f8dAcuILDrPk-UJaKDI",
    authDomain: "bd-riders1.firebaseapp.com",
    projectId: "bd-riders1",
    storageBucket: "bd-riders1.appspot.com",
    messagingSenderId: "559958723916",
    appId: "1:559958723916:web:e339051eb100dabe6d53e9"
  };
export default firebaseConfig;